// 在组件中
import http from './request.js';

export function getLesson() {
    return http.get('/api/lesson/list');
}
export function getNotice() {
    return http.get('/api/lesson/notice');
}